import axios from 'axios';
import { getApiHost } from '@hotjar/common';
import type { Organization } from '@hotjar/navigation/src/types';

export const getOrgsAndSites = async (userId: number): Promise<Organization[]> => {
  const response = await axios.get(`${getApiHost()}/api/v1/users/${userId}/site-access`);

  return response.data.active_sites ?? [];
};
